import {NgModule, Component, Input, ContentChildren, QueryList, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Renderer2} from '@angular/core';
import { Tab } from "./tab.component";

@Component({
	selector: 'tabs-view',
	templateUrl:'tabs-view.template.html',
    styleUrls:['tabs-view.style.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsView {    
    @Input() selectedIndex:number = 0;
    @Input() list:Array<any>;
    @ContentChildren(Tab) tabs:QueryList<Tab>;

    selectedTab:ElementRef;
    ready:boolean;
    numTabs:number = 0;

    private changes:boolean = false;

    constructor(protected cd : ChangeDetectorRef, protected renderer:Renderer2) {        
    }

    activeTabs:Array<Tab> = [];

    ngAfterContentInit() {
        this.changes = true;
    }

    ngAfterViewChecked() {
        this.activeTabs = this.tabs.filter(t => t.enabled)
        
        if(this.changes || this.tabs.length != this.numTabs)
        {
            if(this.selectedIndex > this.tabs.length - 1)
            {
                this.selectedIndex = 0;
            }

            if (this.activeTabs.length > 0) {                        
                this.selectTab(this.selectedIndex)
                this.cd.detectChanges()
            }
            this.changes = false;
            this.numTabs = this.tabs.length;
        }
    }

    ngOnChanges(): void {
        this.changes = true;
    }

    selectTab(index:number) {
        //reset current
        if (this.selectedTab) {
            this.toggleSelectedTabVisible(false)
        }
        //set new
        this.selectedTab = this.activeTabs[index];
        this.selectedIndex = index;
        this.toggleSelectedTabVisible(true)
    }

    toggleSelectedTabVisible(state){
        if (state) {
            this.renderer.addClass(this.selectedTab.nativeElement, "active");
        }
        else {
            this.renderer.removeClass(this.selectedTab.nativeElement, "active");
        }
        this.cd.detectChanges()
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/tabs/tabs-view.component.ts